export default {"src":"/_next/static/media/chart_mixed.f64b436b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};